import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import axios from "axios";
import { BASE_URL, security_key } from "../../../global";

// function createData(name, calories, fat, carbs, protein, price) {
//     return {
//         name,
//         calories,
//         fat,
//         carbs,
//         protein,
//         price,
//         history: [
//             {
//                 date: "2020-01-05",
//                 customerId: "11091700",
//                 amount: 3,
//             },
//             {
//                 date: "2020-01-02",
//                 customerId: "Anonymous",
//                 amount: 1,
//             },
//         ],
//     };
// }

function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);
    let history = [];
    try {
        history = JSON.parse(row.history);
    } catch (error) {
        console.error("Error parsing history:", error);
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    return (
        <React.Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <i class="fa-solid fa-angle-up"></i> : <i class="fa-solid fa-angle-down"></i>}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {row.ac_name}
                </TableCell>
                <TableCell align="right">{row.view_count}</TableCell>
                <TableCell align="right">{formatDate(row.ac_publish_date)}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="h6" gutterBottom component="div">
                                History
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>View Date</TableCell>
                                        <TableCell>Viewer Device IP</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(history) &&
                                        history.map((historyRow) => (
                                            <TableRow key={formatDate(historyRow.created_on)}>
                                                <TableCell component="th" scope="row">
                                                    {formatDate(historyRow.created_on)}
                                                </TableCell>
                                                <TableCell>{historyRow.device_ip}</TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

// const rows = [
//     createData("Frozen yoghurt", 159, 6.0, 24, 4.0, 3.99),
//     createData("Ice cream sandwich", 237, 9.0, 37, 4.3, 4.99),
//     createData("Eclair", 262, 16.0, 24, 6.0, 3.79),
//     createData("Cupcake", 305, 3.7, 67, 4.3, 2.5),
//     createData("Gingerbread", 356, 16.0, 49, 3.9, 1.5),
// ];

const ArticleViewHistory = ({ fk_user_key }) => {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        if (fk_user_key) {
            fetchData(fk_user_key);
        }
    }, [fk_user_key]);

    const fetchData = async (fk_user_key) => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getShareTrackData",
                user_key: fk_user_key,
            });
            const output = response.data;
            if (output && Array.isArray(output)) {
                setArticles(output);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table" className="table table-bordered mb-0">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>Article Name</TableCell>
                        <TableCell align="right">View count</TableCell>
                        <TableCell align="right">Publish Date</TableCell>
                        {/*<TableCell align="right">Carbs&nbsp;(g)</TableCell>
                        <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {articles.map((row) => (
                        <Row key={row.ac_name} row={row} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ArticleViewHistory;
